import Typography from "../Typography/Typography";
import styles from "./style.module.css";
import { useState, useEffect, useRef } from "react";

export interface Option {
  value: "Confirmed" | "Pending" | "Processed";
  label: "Confirmed" | "Pending" | "Processed";
}

interface StatusSelectorProps {
  value?: "Confirmed" | "Pending" | "Processed";
  options: Option[];
  onChange?: (value: "Confirmed" | "Pending" | "Processed") => void;
}

export const StatusSelector: React.FC<StatusSelectorProps> = ({
  value,
  options,
  onChange,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const selected = options.find((opt) => opt.value === value);

  const handleSelect = (val: Option["value"]) => {
    onChange?.(val);
    setOpen(false);
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const containerClass =
    selected?.value === "Confirmed"
      ? styles.statContainerGreen
      : (selected?.value === "Pending" ? styles.statContainerOrange : styles.statContainerBlue);

  const textClass =
    selected?.value === "Confirmed" ? styles.statGreen : (selected?.value === "Pending" ? styles.statOrange : styles.statBlue);

  const arrowClass =
    selected?.value === "Confirmed" ? styles.arrowGreen : (selected?.value === "Pending" ? styles.arrowOrange : styles.arrowBlue);

  return (
    <div className={styles.container} ref={dropdownRef}>
      <button
        type="button"
        className={containerClass}
        onClick={() => setOpen((prev) => !prev)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <Typography className={textClass}>{selected?.label}</Typography>
        <div
          className={`${styles.arrow} ${open ? styles.arrowOpen : ""} ${arrowClass}`}
        ></div>
      </button>

      {open && (
        <ul className={styles.menu} role="listbox">
          {options.map((opt) => (
            <li
              key={opt.value}
              role="option"
              aria-selected={opt.value === value}
              className={`${styles.option} ${opt.value === value ? styles.selected : ""
                }`}
              onClick={() => handleSelect(opt.value)}
            >
              <div
                className={
                  opt.value === "Confirmed"
                    ? styles.menuContainerGreen
                    : (opt.value === "Pending" ? styles.menuContainerOrange : styles.menuContainerBlue)
              }
              >
              <Typography
                className={
                  opt.value === "Confirmed" ? styles.statGreen : (opt.value === "Pending" ? styles.statOrange : styles.statBlue)
                }
              >
                {opt.label}
              </Typography>
            </div>
            </li>
      ))}
    </ul>
  )
}
    </div >
  );
};
